var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.busy},on:{"click":_vm.connect}},[(_vm.busy)?_c('span',{staticClass:"spinner-border spinner-border-sm mr-1",attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"fas fa-wallet mr-1"}),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }